<template>
  <v-container>
    <div class="header d-flex flex-column align-center text-center">
      <div class="h-text">
        <h1>고객 맞춤형 합성 견적 요청서</h1>
        <h4 >
          아래 표시된 정보를 모두 기입하셔야 신속한 답변을 받을 수 있습니다.
        </h4> 
      </div>
      <img src="../assets/bg_item.png" alt class="h-item" />
    </div>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      class="form mx-auto my-7 my-sm-12 px-7 px-sm-0"
    >
      <p class="req-text">* 표시는 필수입력사항</p>
      <!-- 회사명 -->
      <label for><span class="req">*</span>회사명</label>
      <v-text-field
        v-model="company"
        :rules="compRules"
        color="#2DBECD"
        class="mt-0 pt-0 mb-5"
        required
      ></v-text-field>
      <!-- 요청자 이름 -->
      <label for><span class="req">*</span>요청자 이름</label>
      <v-text-field
        v-model="name"
        :rules="nameRules"
        color="#2DBECD"
        class="mt-0 pt-0 mb-5"
        required
      ></v-text-field>
      <!-- 요청자 전화번호 -->
      <label for><span class="req">*</span>요청자 전화번호</label>
      <v-text-field
        v-model="phone"
        :rules="phoneRules"
        color="#2DBECD"
        hint="하이픈(-) 제외"
        class="mt-0 pt-0 mb-5"
        required
      ></v-text-field>
      <!-- 이메일 주소 -->
      <label for><span class="req">*</span>요청자 이메일 (화학 구조 등 별도의 추가 사항 보낼 시 필요)</label>
      <v-text-field
        v-model="email"
        :rules="emailRules"
        color="#2DBECD"
        class="mt-0 pt-0 mb-5"
        required
      ></v-text-field>
      <!-- 화학명 -->
      <label for><span class="req">*</span>화학명</label>
      <v-text-field
        v-model="chemistry"
        :rules="chemiRules"
        color="#2DBECD"
        class="mt-0 pt-0 mb-5"
        required
      ></v-text-field>
      <!-- CAS No. -->
      <label for><span class="req">*</span>CAS No.</label>
      <v-text-field
        v-model="casNo"
        :rules="casNoRules"
        color="#2DBECD"
        class="mt-0 pt-0 mb-5"
        required
      ></v-text-field>
      <!-- 구조식 이미지 첨부 -->
      <label for><span class="req">*</span>구조식 이미지 첨부</label>
      <v-file-input 
        v-model="imageFile"
        :rules="imageRules"
        accept="image/*" 
        class="mt-0 pt-0 mb-5"
        show-size
      ></v-file-input>
      <!-- 물질 순도 -->
      <label for><span class="req">*</span>물질 순도 (%)</label>
      <v-text-field
        v-model="substance_purity"
        :rules="substance_purityRules"
        color="#2DBECD"
        class="mt-0 pt-0 mb-5"
      ></v-text-field>
      <!-- 수량 -->
      <label for><span class="req">*</span>요청 수량 (g)</label>
      <v-text-field
        v-model="count"
        :rules="cntRules"
        color="#2DBECD"
        class="mt-0 pt-0 mb-5"
        required
      ></v-text-field>
      <!-- 예상 재 합성 요청 횟수 -->
      <label for><span class="req">*</span>예상 재 합성 요청 횟수 (원하는 성능이 나왔을 경우)</label>
      <v-text-field
        v-model="recount"
        :rules="recountRules"
        color="#2DBECD"
        class="mt-0 pt-0 mb-5"
        required
      ></v-text-field>
      <!-- 양산 가능성 -->
      <label for><span class="req">*</span>양산 가능성 (O,X)(원하는 성능이 나왔을 경우)</label>
      <v-text-field
        v-model="possibility"
        :rules="possibilityRules"
        color="#2DBECD"
        class="mt-0 pt-0 mb-5"
        required
      ></v-text-field>
      <!-- 물질 사용 용도 -->
      <label for><span class="req">*</span> 물질 사용 용도</label>
      <v-text-field
        v-model="use"
        :rules="useRules"
        color="#2DBECD"
        class="mt-0 pt-0 mb-5"
      ></v-text-field>
      <!-- 기타 분석 요청 사항 -->
      <label for>기타 분석 요청 사항</label>
      <v-text-field
        v-model="etc"
        color="#2DBECD"
        class="mt-0 pt-0 mb-5"
      ></v-text-field>
      <!-- 수신 동의 -->
      <label for
        >머크에서 제공하는 정보 및 제품 홍보 등 마케팅 안내 관련 수신에
        동의합니다. ('아니오'를 하실 경우, 관련 할인 공지 대상에서
        제외됨)</label
      >
      <v-radio-group 
        v-model="agree" 
        :rules="agreeRules"  
        class="radio" 
        required>
        <v-radio label="네" value="true" color="#2DBECD"></v-radio>
        <v-radio label="아니오" value="false" color="#2DBECD"></v-radio>
      </v-radio-group>

      <!-- 제출하기 -->
      <v-btn
        :disabled="!valid"
        color="#A5CD50"
        class="d-block mt-7 mt-sm-12 mx-auto font-weight-bold btn"
        @click="validate"
        >제출하기</v-btn
      >

      <!-- 텍스트 -->
      <div class="contact mt-sm-10 mt-8">
        기타 문의사항은
        <span>머크생명과학 New Business &amp; Sales Development 팀</span>
        (custom_kr@merckgroup.com)에 문의 부탁드립니다.
      </div>

           <!-- sns 아이콘 -->
      <div class="sns mt-9 mt-sm-10">
        <a href="http://pf.kakao.com/_JQfwj" class="mr-sm-3 mx-2" target="_blank">
          <img src="../assets/icon_kakao.png" alt="">
        </a>
        <a href="https://www.youtube.com/channel/UC1q6842hLnsMG_0JdHs4KWw/" class="mx-sm-0 mx-2" target="_blank">
          <img src="../assets/icon_youtube.png" alt="">
        </a>
      </div> 
    </v-form>

    <v-overlay :value="isLoading" :opacity="0.2">
      <v-btn icon>
        <v-progress-circular
          :size="50"
          color="#2DBECD"
          indeterminate
        ></v-progress-circular>
      </v-btn>
    </v-overlay>

    <v-row justify="center">
      <v-dialog v-model="dialog" max-width="290" class="dialog">
        <v-card>
          <v-card-title class="headline">접수 완료</v-card-title>
          <v-card-text>
            정상적으로 요청이 접수되었습니다.<br />요청하신 내용에 대해 신속한 답변
            드리도록 하겠습니다.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#2DBECD" text @click="dialog = false">
              확인
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    dialog: false,
    isLoading: false,
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "요청자 이름을 입력해주세요."
      // v => (v && v.length <= 10) || "Name must be less than 10 characters"
    ],
    phone: "",
    phoneRules: [
      v => !!v || "요청자 전화번호를 입력해주세요.",
      v => /^[0-9]*$/.test(v) || "형식에 맞지않는 번호 입니다.",
      v => (v && v.length <= 11) || "형식에 맞지않는 번호 입니다."
    ],
    email: "",
    emailRules: [
      v => !!v || "요청자 이메일을 입력해주세요.",
      v => /.+@.+\..+/.test(v) || "이메일 주소 형식이 아닙니다."
    ],
    company: "",
    compRules: [v => !!v || "회사명을 입력해주세요."],
    chemistry: "",
    chemiRules: [v => !!v || "화학명을 입력해주세요."],
    casNo: "",
    casNoRules: [v => !!v || "CAS No.를 입력해주세요."],
    imageFile: null,
    imageRules: [
      v => !!v || "이미지를 첨부해주세요.",
      v => !v || v.size < 10485760 || '최대 이미지 용량은 10 MB 입니다.'
    ],
    substance_purity: "",
    substance_purityRules: [
      v => !!v || "물질 순도를 입력해주세요.",
      v => /^\d*([.]\d+)?$/.test(v) || "숫자로 입력해주세요."
    ],
    count: "",
    cntRules: [ 
      v => /^[0-9]*$/.test(v) || "숫자로 입력해주세요.",
      v => !!v || "수량을 입력해주세요."
    ],
    recount: "",
    recountRules: [
      v => /^[0-9]*$/.test(v) || "숫자로 입력해주세요.",
      v => !!v || "횟수를 입력해주세요."
    ],
    possibility: "",
    possibilityRules: [
      v => !!v || "양산 가능성을 O,X로 입력해주세요.",
      v => (String(v).toLowerCase() === 'o' || String(v).toLowerCase() === 'x') || "양산 가능성을 O,X로 입력해주세요."
    ],
    use: "",
    useRules: [
      v => !!v || "물질 사용 용도를 입력해주세요."
    ],
    etc: "",
    agree: "",
    agreeRules: [v => !!v || "수신 동의 여부를 체크해주세요."]
  }),
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.isLoading = true; 

        const formData = new FormData()
        formData.append('to', 'custom_kr@merckgroup.com')
        formData.append('name', this.name)
        formData.append('phone', this.phone)
        formData.append('email', this.email)
        formData.append('company', this.company)
        formData.append('chemistry', this.chemistry)
        formData.append('casNo', this.casNo)
        formData.append('substance_purity', this.substance_purity)
        formData.append('count', this.count)
        formData.append('recount', this.recount)
        formData.append('possibility', this.possibility)
        formData.append('use', this.use)
        formData.append('etc', this.etc)
        formData.append('agree', this.agree)
        if(this.imageFile) {
          formData.append('files', this.imageFile)
        }
        
        // for (let key of formData.entries()) {
        //   console.log(`${key}`)
        // }

        axios
          .post("https://us-central1-merck-customsynthesis.cloudfunctions.net/sendMail", formData, {
            headers: {
              'Content-Type' : 'multipart/form-data'
            }
          })
          .then(() => {
            this.dialog = true;
            this.reset();
          })
          .catch(() => {})
          .finally(() => {
            this.isLoading = false;
          });
      }
      /*
      if (this.$refs.form.validate()) {
        this.isLoading = true; 

        const data = {
          name: this.name,
          phone: this.phone,
          email: this.email,
          company: this.company,
          address: this.address,
          country: this.country,
          chemistry: this.chemistry,
          count: this.count,
          agree: this.agree
        };

        const formData = new FormData()
        formData.append('name', this.name)
        


        axios
          // .post("/sendMail", data)
          .post("http://localhost:5001/merck-customsynthesis/us-central1/sendMail", data)
          .then(() => {
            this.isLoading = false;
            this.dialog = true;
            this.$refs.form.reset();
          })
          .catch(() => {
            this.isLoading = false;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
      */
    },
    reset() {
      this.$refs.form.reset()
      this.imageFile = null
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Noto Sans KR", sans-serif;
  letter-spacing: -0.3px;
}
p {
  margin: 0 !important;
  padding: 0 !important;
  color: #303030;
}
img {
  max-width: 100%;
}
p.req-text {
  font-size: 12px;
  text-align: right;
  color:#ed4e4e;
}
span.req {
  color: #ed4e4e;
}
.container {
  max-width: 1200px;
  min-width: 320px;
  padding: 0 !important;
}
.header {
  position: relative;
  width: 100%;
  height: 400px;
  max-height: 400px;
  box-sizing: border-box;
  color: #503291;
  background: {
    image: url(../assets/bg_header.png);
    color: #a5cd50;
    repeat: no-repeat;
    size: cover;
    position: center;
  }
  .h-text {
    margin-top: 50px;
    line-height: 1;
    h1 {
      font-size: 32px;
      letter-spacing: -1px;
      margin-bottom: 30px;
    }
    h4 {
      font-size: 18px;
      font-weight: normal;
      letter-spacing: -1.2px;
    }
  }
  .h-item {
    position: absolute;
    bottom: 0;
  } 
}
.form {
  max-width: 540px;
}
.btn {
  color: #503291 !important;
  box-shadow: none;
  font-size: 18px !important;
  width: 200px;
  height: 52px !important;
  border-radius: 5px;
}

.v-card__text {
  letter-spacing: -0.5px;
  word-break: keep-all;
}
.contact {
  color: #505050;
  font-size: 14px;
  letter-spacing: -0.8px;
  word-break: keep-all;
  span {
    font-weight: bold;
  }
}  
.sns {
  text-align: right;
  a { 
    display: inline-block;
    width: 48px;
    height: 48px;
  }
}
@media (max-width: 750px) {
  .header {
    width: 100%;
    background: {
      image: url(../assets/bg_m_header.png);
      color: #2dbecd;
      repeat: no-repeat;
      size: cover;
      position: center;
    }
  }
}
@media (max-width: 600px) {
  .header {
    height: 240px;
    img {
      max-width: 250px;
      width: 65%;
    }
    .h-text {
      margin-top: 36px; 
      h1 {
        font-size: 24px;
        margin-bottom: 20px;
      }
      h4 {
        font-size: 14px; 
        max-width: 210px;
        word-break: keep-all;
        margin: 0 auto;
        line-height: 1.3;
      }
    } 
  }
  label {
    font-size: 13px;
  }
  .btn {
    width: 170px;
    height: 40px;
    font-size: 16px !important;
  }
  label.v-label.theme--light {font-size: 13px;}
  .contact {
    font-size: 13px;
    text-align: center;
  } 
  .sns { 
    text-align: center;
    a {
      width: 60px;
      height: 60px;
    }
  }
}
</style>
